import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatPrice = (cents: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
};

/** Parse a user-typed dollar amount ("1,000", "$1000.50") into integer cents.
 *  Blank / unparseable input returns null (treated as "unpriced"). */
export const dollarsToCents = (input: string): number | null => {
  const cleaned = (input ?? "").replace(/[^0-9.]/g, "");
  if (cleaned === "" || cleaned === ".") return null;
  const dollars = parseFloat(cleaned);
  if (!Number.isFinite(dollars)) return null;
  return Math.round(dollars * 100);
};

/** Render integer cents as a plain editable dollar string ("1000.5"), no symbol. */
export const centsToDollarsInput = (cents: number | null | undefined): string =>
  cents == null ? "" : String(cents / 100);

/**
 * Converts a string to title case (first letter of each word capitalized).
 * Handles all caps, all lowercase, and mixed case input.
 */
export const toTitleCase = (str: string): string => {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
